import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import s from './Home.css';
import * as actions from '../../actions/home';
import Layout from '../../components/global/Layout';
import LoadMore from '../../components/common/LoadMore';
import Nav from '../../components/p_home/Nav'
import SlideArea from '../../components/p_home/SlideArea'
import Section from '../../components/p_home/Section'
import Pop from '../../components/p_home/Pop'
import PrivacyPolicy from '../../components/p_home/PrivacyPolicy'
import storage from '../../core/storage'

class Home extends React.Component {

  constructor(props) {
    super(props)
    this.loadHomeMore = this.loadHomeMore.bind(this)
  }

  componentDidMount() {
    const { home, showPop } = this.props
    if (home.popup) {
      const storageData = storage.load()
      if (!storageData || (storageData && !storageData[home.popup.url])) {
        showPop()
      }
    }
  }

  loadHomeMore() {
    const { homeMoreFetch, home } = this.props
    if (home.tagRecommends.length === 0) return null
    const tagIds = home.tagRecommends.slice(0, 4)
    return homeMoreFetch(tagIds)
  }

  render() {
    const { home, closePop } = this.props;
    if (!home || !home.fixedEntries) return null
    return (
      <Layout>
        <Nav tags={home.fixedEntries} />
        <SlideArea
          head={home.head}
          popularCourses={home.popularCourse}
          discover={home.discover}
          serialCourse={home.serial}
        />
        <div className={s.content}>
          {/* {home.essay && home.essay.length !== 0 ? <Essays essays={home.essay} /> : null}*/}
          {
            home.tagRecommendCourses.map((tag, inx) => (
              <Section key={`sec-${inx}-${tag.tag.id}`} data={tag} />
            ))
          }
          <LoadMore
            onReachBottom={this.loadHomeMore}
            hasMore={home.tagRecommends.length !== 0}
          />
          {
            home.pop && home.popup ?
              <Pop data={home.popup} closePop={closePop} /> : null
          }
        </div>
        <PrivacyPolicy />
      </Layout>
    );
  }
}

Home.propTypes = {
  home: PropTypes.shape({
    fixedEntries: PropTypes.array.isRequired,
    layout: PropTypes.array.isRequired,
    tagRecommends: PropTypes.array.isRequired,
    inited: PropTypes.bool.isRequired,
    pop: PropTypes.bool.isRequired,
    discover: PropTypes.array.isRequired,
    serial: PropTypes.array,
  }).isRequired,
  homeMoreFetch: PropTypes.func.isRequired,
  showPop: PropTypes.func.isRequired,
  closePop: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Home))



// WEBPACK FOOTER //
// ./src/routes/home/Home.js